// extracted by mini-css-extract-plugin
module.exports = {"dotButton":"dot-buttons_dotButton__Ig_Vo","dotButton__active":"dot-buttons_dotButton__active__WWAH5","dotButtons":"dot-buttons_dotButtons__3d1uJ"};